import { render } from "./the-progress-bar.vue?vue&type=template&id=85964f80&ts=true"
import script from "./the-progress-bar.vue?vue&type=script&lang=ts"
export * from "./the-progress-bar.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__